import { Suspense, useEffect } from "react";
import { Stars } from "@react-three/drei";
import { Physics } from "@react-three/rapier";
import { threeColors } from "../theme/tokens";
import { useGameStore, getAutoDripMs } from "../state/useGameStore";
import { CentralCollider, CentralObject } from "../entities/CentralObject";
import { FragmentCubes } from "../entities/FragmentCube";
import { Ground } from "../entities/Ground";
import { Lights } from "./Lights";
import { CameraRig } from "./CameraRig";
import { PostFX } from "./PostFX";

function AutoDrip() {
  const autoDrip = useGameStore((s) => s.autoDrip);
  const autoDripMs = useGameStore((s) => s.autoDripMs);
  const drip = useGameStore((s) => s.drip);
  const phase = useGameStore((s) => s.phase);

  useEffect(() => {
    if (!autoDrip || phase === "intro") return;
    const ms = autoDripMs || getAutoDripMs();
    const id = setInterval(() => drip(), ms);
    return () => clearInterval(id);
  }, [autoDrip, autoDripMs, drip, phase]);

  return null;
}

export default function Experience() {
  const phase = useGameStore((s) => s.phase);
  const climaxActive = useGameStore((s) => s.climaxActive);
  const reducedMotion = useGameStore((s) => s.reducedMotion);
  const coarsePointer = useGameStore((s) => s.coarsePointer);

  const starCount = coarsePointer ? 900 : reducedMotion ? 1200 : 2800;

  return (
    <>
      <color attach="background" args={[threeColors.ink]} />
      <fog attach="fog" args={[threeColors.ink, 32, 90]} />

      <Lights climax={climaxActive} />
      <CameraRig />
      <AutoDrip />

      <CentralObject />

      <Suspense fallback={null}>
        <Physics gravity={[0, -9.81, 0]}>
          <CentralCollider />
          {phase !== "intro" && (
            <>
              <FragmentCubes />
              <Ground />
            </>
          )}
        </Physics>
      </Suspense>

      <Stars
        radius={55}
        depth={35}
        count={starCount}
        factor={reducedMotion ? 2 : 2.8}
        saturation={0}
        fade
        speed={reducedMotion ? 0 : 0.35}
      />

      {!reducedMotion && !coarsePointer && <PostFX />}
    </>
  );
}
